module.exports = require("serve-static");


//////////////////
// WEBPACK FOOTER
// external "serve-static"
// module id = 20
// module chunks = 0